module.exports = __webpack_public_path__ + "static/kobe-8-775ddbf9a53038dd4b6ac644d11ca1b9.jpg";